import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router";
import DataTable from "../../../components/Common/DataTable/DataTable";
import { useDispatch } from "react-redux";
import { useFetchData } from "../../../hooks/useFetchData";
import {
  eventGetPublishedByMeActionHandler,
  deleteEventShotclassActionHandler,
} from "../../../store/actions/actionHandlers/eventActionHandler";
import { eventPublishedByMe } from "../../../utils/mainTabs/events/eventPublishedByMe";
import Modal from "../../../components/Common/Modal/Modal";
import classes from "./EventPublishedByMe.module.scss";
import { setErrorHandler } from "../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../utils/errorTypes";
import { FormattedMessage } from "react-intl";

const EventPublishedByMe = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const pageSize = 8;
  const {
    data,
    setData,
    updatedData,
    setUpdatedData,
    totalRows,
    handleCurrentPage,
    handleSearchQuery,
    loading,
  } = useFetchData(eventGetPublishedByMeActionHandler, pageSize);
  const { tenantName, refreshAPIS, setRefreshAPIS } = useOutletContext();
  const { searchPlaceHolder, columns } = eventPublishedByMe;
  const [shotclassId, setShotclassId] = useState(0);
  const [tableColumns, setTableColumns] = useState([]);
  useEffect(() => {
    if (refreshAPIS) {
      handleSearchQuery("");
      setRefreshAPIS(false);
    }
  }, [refreshAPIS]);
  const handleDeleteModal = useCallback((shotclassId) => {
    setShotclassId(shotclassId);
  }, []);
  const handleDeleteShotclass = () => {
    // dispatch(
    //   deleteEventShotclassActionHandler(
    //     shotclassId,
    //     data,
    //     updatedData,
    //     setData,
    //     setUpdatedData,
    //     handleSearchQuery
    //   )
    // );
    // handleDeleteModal(0);
    dispatch(
      deleteEventShotclassActionHandler(
        shotclassId
        // data,
        // updatedData,
        // setData,
        // setUpdatedData,
        // handleSearchQuery
      )
    ).then((isDeleted) => {
      if (isDeleted) {
        dispatch(setErrorHandler(errorTypes.SUCCESS, "Event has been deleted"));
        const filteredData = data.filter((row) => row.ID !== shotclassId);
        const filteredUpdatedData = updatedData.filter(
          (row) => row.ID !== shotclassId
        );
        setData(filteredData);
        setUpdatedData(filteredUpdatedData);
      }
    });
    handleDeleteModal(0);
  };

  useEffect(() => {
    let newTableColumns = columns(navigate, handleDeleteModal, tenantName);
    setTableColumns(newTableColumns);
  }, [columns, navigate, handleDeleteModal, tenantName]);
  return (
    <>
      <DataTable
        columns={tableColumns}
        defaultData={data}
        setDefaultData={setData}
        data={updatedData}
        setData={setUpdatedData}
        totalRows={totalRows}
        uniqueFieldName={"uniqueFieldName"}
        fetchMoreData={handleCurrentPage}
        searchable
        setSearchQuery={handleSearchQuery}
        placeholder={searchPlaceHolder}
        loading={loading}
      />
      <Modal
        handleSubmit={handleDeleteShotclass}
        isOpen={shotclassId}
        // heading={"Shotclasses Message"}
        toggle={() => handleDeleteModal(0)}
        buttonLabel1={<FormattedMessage id="YES_TEXT" />}
        buttonLabel2={<FormattedMessage id="USERGRP_CANCELBTN_TEXT" />}
        width={"46.2"}
        height={"26.9"}
      >
        <div className={classes.eventPublishedByMe__deleteModal}>
          <div className={classes.eventPublishedByMe__deleteModal__text}>
            Are you sure you want to delete this event?
          </div>
        </div>
      </Modal>
    </>
  );
};

export default EventPublishedByMe;
